import { render, staticRenderFns } from "./workshop-card.vue?vue&type=template&id=0e83da6c&scoped=true"
import script from "./workshop-card.vue?vue&type=script&lang=js"
export * from "./workshop-card.vue?vue&type=script&lang=js"
import style0 from "./workshop-card.vue?vue&type=style&index=0&id=0e83da6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e83da6c",
  null
  
)

export default component.exports